export default {"src":"/_next/static/media/arrow-left-white.c300aebc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};